<template>
  <div class="card edit_server">
    <div class="header">
      <h4 class="title">
        {{ translate('server.edit') }}
      </h4>
    </div>
    <div class="content">
      <div class="line">
        <fg-input
          v-model="upd_server.name"
          type="text"
          label="Name"
          :placeholder="translate('server.name')"
        />
        <fg-input
          v-model="upd_server.name_short"
          type="text"
          :label="translate('server.name_short')"
          :placeholder="translate('server.name_short')"
        />
      </div>
      <div class="line">
        <div class="form_group group">
          <sis-select
              v-model="upd_server.server_group_id"
              :options="listServer"
              :options_limit="100"
              :multiple="false"
              :close_on_select="true"
              :clearable="false"
              :hide_selected="true"
              :max_height="165"
              :label="translate('server.groups')"
              :placeholder="translate('server.groups')"
          />
        </div>

      </div>
      <div class="line edit-server_ip-wrap">
        <fg-input
          v-model="upd_server.ip"
          type="text"
          label="IP"
          placeholder="IP"
          :disabled="true"
        />
        <div class="ports_list">
          <div
            v-for="(port,key) in upd_server.ports"
            :key="key"
            class="line "
          >
            <fg-input
              class="edit-server_ports"
              v-model="port.port"
              type="text"
              :label="translate('ip_profile.port') + '(' + type(port.type) + ')'"
              :placeholder="translate('ip_profile.port')"
              :disabled="true"
            />
            <fg-input
              class="edit-server_ports"
              v-model="port.internal_ip"
              type="text"
              :label="translate('ip_profile.internal_ip')"
              :placeholder="translate('internal_ip')"
            />
          </div>
        </div>
      </div>

      <div class="line">
        <fg-input
          v-model="upd_server.place"
          type="text"
          :label="translate('server.place')"
          :placeholder="translate('server.place')"
        />

        <div class="backup-wrap form-group">
          <toggle-switch-simple
            id="backup"
            class="backup"
            v-model="upd_server.backup"
            :label="translate('server.backup')"
          />
        </div>

        <fg-input
          v-if="upd_server.backup === 1"
          v-model="upd_server.backup_priority"
          type="number"
          :min="0"
          :label="translate('server.priority')"
          :placeholder="translate('server.priority')"
        />
      </div>

      <div class="text-center">
        <button
          type="submit"
          class="btn btn-info btn-fill btn-wd"
          @click.prevent="updateProfile"
        >
          {{ translate('server.update') }}
        </button>
        <button
          type="submit"
          class="btn btn-danger btn-fill btn-wd"
          @click.prevent="cancel"
        >
          {{ translate('to_cancel') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import ToggleSwitchSimple from 'components/UIComponents/ToggleSwitch/ToggleSwitchSimple.vue'

export default {
  components: {
    ToggleSwitchSimple
  },
  props: {
    server: Object,
    groups_servers: Array
  },
  data () {
    return {
      upd_server: {}
    }
  },
  beforeMount () {
    this.upd_server = {...this.server}
  },
  computed:{
    listServer(){
      let list = []
      for (let group of this.groups_servers) {
        list.push({id: group.id, label: group.name})
      }
      return list
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    type (type) {
      let types = {1: 'multilink', 2: 'stcp'}
      return types[type]
    },
    updateProfile () {
      this.$emit('update', this.upd_server)
      this.$emit('close', this.upd_server)
    }
  }
}
</script>
<style lang="scss">
  .edit_server{
    .header{
      .title{
        text-align: center;
      }
    }
    .content{
      .line{
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .form-group{
        width: 49.5%;
        &.sis-input{
          width: 100%;
        }
      }
      .ports_list{
        width: 50%;
        overflow-y: auto;
        overflow-x: hidden;
        max-height: 120px;


        .edit-server_ports label {
          font: 300 1.15rem/20px 'Roboto', Arial, sans-serif !important;
          height: 20px !important;
          box-sizing: border-box !important;
        }
        .edit-server_ports input {
          font: 300 1.15rem/1.5rem 'Roboto', Arial, sans-serif !important;
          height: 2.5rem !important;
          box-sizing: border-box !important;
        }
        .edit-server_ports [class*="col-"] {
          padding-top: 0 !important;
          padding-bottom: 0 !important;
        }
      }
      .backup{
        display: block;
        text-align: center;
        &_wrap{
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
    }

  }

</style>
